<template>
    <div>
        <div class="card border-primary mb-3">
            <div class="card-body">
                <!--<h5 class="card-title">Special title treatment</h5>-->
                <!--{{model}}-->

                <div class="row">
                    <div class="form-group col-12">
                        <label class="font-weight-bold required" :for="'roleName' + _uid">
                            {{$t('aspNetRole.name')}}
                        </label>
                        <input type="text" class="form-control"
                               v-model="model.name"
                               v-validate="'required'"
                               :data-vv-as="$t('aspNetRole.name')"
                               :name="'roleName' + _uid"
                               :id="'roleName' + _uid">
                        <span class="text-danger col-12" v-if="errors.has('roleName' + _uid)">{{ errors.first('roleName' + _uid) }}</span>

                    </div>
                </div>

                <div class="row">
                    <div class="form-group col-12">
                        <label class="font-weight-bold" :for="'description' + _uid">
                            {{ $t('aspNetRole.description')}}
                        </label>
                        <input type="text"
                               class="form-control"
                               v-model="model.description"
                               v-validate="''"
                               :data-vv-as="$t('aspNetRole.description')"
                               :name="'description' + _uid"
                               :id="'description' + _uid" />
                        <span class="text-danger" v-if="errors.has('description' + _uid)">{{ errors.first('description' + _uid) }}</span>
                    </div>
                </div>

                <div class="row">
                    <div class="form-group col-12 mt-3">
                        <vs-checkbox v-model="model.deactivated"
                                     :name="'deactivated' + _uid"
                                     :id="'deactivated' + _uid"
                                     style="justify-content: flex-start !important">
                            {{ $t('aspNetRole.deactivated') }}
                        </vs-checkbox>
                    </div>
                </div>


            </div>

            <div class="footer">
                <div class="text-right mt-3">
                    <div class="btn-group" role="group" aria-label="Role edit buttons">
                        <button type="button" class="btn btn-success" @click.stop="onSave"><i class="fas fa-save mr-2"></i>{{ $t('buttons.save.btnText')}}</button>
                        <button type="button" class="btn btn-danger" @click.stop="onCancel"><i class="fas fa-ban mr-2"></i>{{ $t('buttons.cancel')}}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { Role } from '../../../models/models';
    import { Culture } from '../../../models/enums';
    import roleService from '../../../services/role.service';


    export default {
        inject: ['$validator'],
        props: {
            value: {
                type: Role,
                required: false
            },
            create: {
                type: Boolean,
                default: false
            },
        },
        components: {

        },
        data() {
            return {
                model: this.value
            }
        },
        methods: {
            onCancel() {
                this.$emit("cancel");
            },
            onSave() {
                this.$validator.validateAll().then(result => {
                    if (result) {
                        this.doSave();
                    }
                });
            },
            doSave() {
                if (this.create && this.isNew) {
                    this.createRole();
                } else {
                    this.updateRole();
                }
            },
            createRole() {
                roleService
                    .create(this.model)
                    .then(response => {

                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.responseStatusCode(response)),
                            text: this.$helpers.responseMessage(response),
                            color: 'success',
                            time: this.$store.getters.notificationDuration
                        });

                        this.$emit("save", this.model);
                    })
                    .catch(error => {
                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                            text: this.$helpers.errorText(error),
                            color: this.$helpers.errorColor(error),
                            time: this.$store.getters.notificationDuration
                        })
                    });
            },
            updateRole() {
                roleService
                    .update(this.model)
                    .then(response => {
                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.responseStatusCode(response)),
                            text: this.$helpers.responseMessage(response),
                            color: 'success',
                            time: this.$store.getters.notificationDuration
                        });

                        this.$emit("save", this.model);
                    })
                    .catch(error => {
                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                            text: this.$helpers.errorText(error),
                            color: this.$helpers.errorColor(error),
                            time: this.$store.getters.notificationDuration
                        })
                    });
            }

        },
        computed: {
            token: function () {
                return this.$store.getters.authToken;
            },
            isEnVersion() {
                return this.$store.getters.currentCulture === Culture.EN;
            },
            isNew() {
                let id = Number(this.model.id);
                return isNaN(id) || id <= 0;
            }
        },
        mounted() {
        },
        watch: {
            value: function (val) {
                if (val) {
                    this.model = new Role(this.value);
                }
            }
        }
    }
</script>

<style scoped>
    input[readonly] {
        background-color: whitesmoke;
    }

    textarea[readonly] {
        background-color: whitesmoke;
    }
</style>
